import {
  inboxWorkflowColumn,
  inboxWorkflowPartialMessage,
  type InboxWorkflowCellComponent,
  type InboxWorkflowTableStepConfig,
} from "@kontextwerk/control-web-frame/inbox-workflow/contract"
import ReviewContactPointsPreconfiguration from "./_modules/review-contact-points-preconfiguration"
import ReviewContactPointDecisionCell from "./_modules/review-contact-point-decision-cell"
import ReviewContactPointPropertyCell from "./_modules/review-contact-point-property-cell"
import ReviewContactPointSourceCell from "./_modules/review-contact-point-source-cell"
import {
  ComparisonCell,
  ContactEditor,
  validateDraft,
  editorReason,
} from "./_modules/contact-point-editor"
import { contactEditorActions } from "../../../../_shared/_logic/contact-row-actions"
import type {
  ContactPointReviewCommitPayload,
  ContactPointReviewDraft,
  ContactPointReviewRow,
} from "./contract"
import { buildContactPointReviewRows, defaultContactPointReviewDraft } from "./_logic/tableRows"

export const reviewContactPointCells: Record<string, InboxWorkflowCellComponent> = {
  reviewContactPointDecision: ReviewContactPointDecisionCell,
  reviewContactPointProperty: ReviewContactPointPropertyCell,
  reviewContactPointSource: ReviewContactPointSourceCell,
  reviewContactPointComparison: ComparisonCell,
}

const contactPointReviewPayload = (
  row: ContactPointReviewRow,
  draft: ContactPointReviewDraft,
): ContactPointReviewCommitPayload => {
  if (!draft.action) throw new Error("Kontaktpunkt-Entscheidung fehlt.")

  return {
    action:
      row.reviewKind === "delete_contact_point" && draft.action !== "delete"
        ? "reject"
        : draft.action,
    contact_point_id: row.existingContactPointId || row.deletionContactPointId,
    replacement_contact_point_id: row.submittedContactPointId,
    customer_id: row.customerId,
    property_id: row.propertyId,
    ...(row.reviewKind === "contact_point_change" && ["append", "replace"].includes(draft.action)
      ? { kind: row.contactPointKind, value: (draft.value ?? row.submittedContactValue).trim() }
      : {}),
  }
}

export const createReviewContactPointsStep = (): InboxWorkflowTableStepConfig<
  ContactPointReviewRow,
  ContactPointReviewDraft,
  ContactPointReviewCommitPayload
> => ({
  kind: "table",
  columns: [
    inboxWorkflowColumn("decision", "Entscheidung", "reviewContactPointDecision"),
    inboxWorkflowColumn("addressLabel", "Liegenschaft", "reviewContactPointProperty", {
      isPrimary: true,
    }),
    inboxWorkflowColumn(
      "previousContact",
      "Bisheriges Kontaktdatum",
      "reviewContactPointComparison",
    ),
    inboxWorkflowColumn("newContact", "Neues Kontaktdatum", "reviewContactPointComparison"),
    inboxWorkflowColumn("sourceLabel", "Herkunft", "reviewContactPointSource"),
  ],
  buildRows: ({ workflow, step, rowOutcomes }) =>
    buildContactPointReviewRows({ workflow, step, rowOutcomes }),
  draft: { create: defaultContactPointReviewDraft, validate: validateDraft },
  rowEditor: ContactEditor,
  rowEditorTitle: "Kontaktdatum bearbeiten",
  editorDisabledReason: ({ row, draft }) => editorReason(row, draft),
  rowActions: (props) => contactEditorActions(props, editorReason(props.row, props.draft)),
  preconfiguration: ReviewContactPointsPreconfiguration,
  buildPayload: contactPointReviewPayload,
  commit: {
    label: "Kontaktdaten speichern",
    successMessage: "Kontaktdaten wurden gespeichert.",
    partialMessage: inboxWorkflowPartialMessage,
  },
})
